"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarcodesSink = void 0;
const barcode_1 = require("client/components/barcode");
const text_field_1 = require("client/components/ui/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./barcodes.less");
let BarcodesSink = class BarcodesSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.barcodeValue = "Hello, world";
    }
    render() {
        return (React.createElement("div", { className: "barcode" },
            React.createElement("h2", null, "Barcode"),
            React.createElement("div", { className: "barcode-block" },
                React.createElement(text_field_1.UiTextField, { label: "Barcode", onChange: (event) => (this.barcodeValue = event.target.value), value: this.barcodeValue }),
                this.barcodeValue && (React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: false, height: 50, lineColor: "#26324e", value: this.barcodeValue })))));
    }
};
__decorate([
    mobx_1.observable
], BarcodesSink.prototype, "barcodeValue", void 0);
BarcodesSink = __decorate([
    mobx_react_1.observer
], BarcodesSink);
exports.BarcodesSink = BarcodesSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/barcodes/barcodes.tsx
// module id = 3613
// module chunks = 0